export default __webpack_public_path__ + "static/media/hotel-fil-2.7616af74.jpg";